var map = {
  "./ru-RU.cjs": [
    "78684",
    9,
    "8835"
  ],
  "./es-ES.cjs": [
    "12154",
    9,
    "9293"
  ],
  "./en-CA.cjs": [
    "94069",
    9,
    "8360"
  ],
  "./fr-FR.cjs": [
    "28814",
    9,
    "2869"
  ],
  "./en-US.cjs": [
    "3341",
    9,
    "9156"
  ],
  "./es-AR.cjs": [
    "92719",
    9,
    "1938"
  ],
  "./ja-JP.cjs": [
    "62421",
    9,
    "7852"
  ],
  "./de-DE.cjs": [
    "51048",
    9,
    "7179"
  ],
  "./ko-KR.cjs": [
    "54263",
    9,
    "270"
  ],
  "./th-TH.cjs": [
    "8498",
    9,
    "2801"
  ],
  "./common/index.cjs": [
    "8131",
    7,
    "8718"
  ],
  "./id-ID.cjs": [
    "56800",
    9,
    "2307"
  ],
  "./en-GB.cjs": [
    "71658",
    9,
    "2881"
  ],
  "./pt-BR.cjs": [
    "52522",
    9,
    "8781"
  ],
  "./it-IT.cjs": [
    "67680",
    9,
    "1251"
  ],
  "./es-419.cjs": [
    "39956",
    9,
    "1769"
  ],
  "./en-IN.cjs": [
    "37492",
    9,
    "8723"
  ],
  "./hi-IN.cjs": [
    "69680",
    9,
    "979"
  ],
  "./en-AU.cjs": [
    "23255",
    9,
    "8666"
  ],
  "./tr-TR.cjs": [
    "40082",
    9,
    "3957"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[2]).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 43976;
module.exports = __rspack_async_context;
